import {forwardRef} from 'external/react'
import {omit} from 'external/lodash'
import {styled} from 'external/material'
import { centerVertically } from 'utils/style'

const StyledDashboardActivityItemColumn = styled('div')(dashboardActivityItemColumnStyles)

const DashboardActivityItemColumn = forwardRef((props, ref) => {
    const {title, content, children} = props
    return(<StyledDashboardActivityItemColumn ref={ref} {...omit(props, 'title', 'content')}>
            <div className="container">
                <div className='title'>{title}</div>
                <div className='content'>{content || children}</div>
            </div>
        </StyledDashboardActivityItemColumn>
   )
})

export {DashboardActivityItemColumn as default}

function dashboardActivityItemColumnStyles(){
    return {
        ...centerVertically,
        "& .container": {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            '& .title': {
                color: '#999999',
                fontWeight: 500,
                fontSize: '8.5pt'
            },
            '& .content': {
                fontSize: '10.0pt',
                color: '#5b6173'
            }
        }
    }
}


